/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AuditLogTableFilterData
} from '../../model/auditLogTableFilterData'
import type {
  AuditLogTableQueryDataRequest
} from '../../model/auditLogTableQueryDataRequest'
import type {
  CustomerData
} from '../../model/customerData'
import type {
  CustomerDataList
} from '../../model/customerDataList'
import type {
  EventExportCreateDataRequest
} from '../../model/eventExportCreateDataRequest'
import type {
  EventImportCreateAPIDataRequest
} from '../../model/eventImportCreateAPIDataRequest'
import type {
  EventImportExportReadData
} from '../../model/eventImportExportReadData'
import type {
  EventLoadCreateAPIDataRequest
} from '../../model/eventLoadCreateAPIDataRequest'
import type {
  EventStatsData
} from '../../model/eventStatsData'
import type {
  EventTemplateEventDeleteDataRequest
} from '../../model/eventTemplateEventDeleteDataRequest'
import type {
  EventTemplateEventJsonData
} from '../../model/eventTemplateEventJsonData'
import type {
  EventTemplateEventOrderStatusDataRequest
} from '../../model/eventTemplateEventOrderStatusDataRequest'
import type {
  EventTemplateEventUpdateDataRequest
} from '../../model/eventTemplateEventUpdateDataRequest'
import type {
  EventTemplateReadData
} from '../../model/eventTemplateReadData'
import type {
  EventTemplateReadDataList
} from '../../model/eventTemplateReadDataList'
import type {
  ExportCustomerEventJsonRecordReadData
} from '../../model/exportCustomerEventJsonRecordReadData'
import type {
  FeatureFlagReadData
} from '../../model/featureFlagReadData'
import type {
  GenericSelectDataList
} from '../../model/genericSelectDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  InternalEventImportExportTableDataRetrieveParams
} from '../../model/internalEventImportExportTableDataRetrieveParams'
import type {
  InternalEventTemplateEventCreateDataRetrieveParams
} from '../../model/internalEventTemplateEventCreateDataRetrieveParams'
import type {
  InternalEventTemplateEventTableDataRetrieveParams
} from '../../model/internalEventTemplateEventTableDataRetrieveParams'
import type {
  InternalFeatureFlagCustomerTableDataRetrieveParams
} from '../../model/internalFeatureFlagCustomerTableDataRetrieveParams'
import type {
  InternalFeatureFlagEditDataRequest
} from '../../model/internalFeatureFlagEditDataRequest'
import type {
  InternalFeatureFlagUserTableDataRetrieveParams
} from '../../model/internalFeatureFlagUserTableDataRetrieveParams'
import type {
  InternalShadowDataRunTableDataRetrieveParams
} from '../../model/internalShadowDataRunTableDataRetrieveParams'
import type {
  InternalUnrelatedUserListParams
} from '../../model/internalUnrelatedUserListParams'
import type {
  LoadEventCheckpointStatusData
} from '../../model/loadEventCheckpointStatusData'
import type {
  LoadEventCheckpointStatusDataRequest
} from '../../model/loadEventCheckpointStatusDataRequest'
import type {
  ModelAuditLogEntryReadDataList
} from '../../model/modelAuditLogEntryReadDataList'
import type {
  MuuidData
} from '../../model/muuidData'
import type {
  ShadowDataRunCreateDataRequest
} from '../../model/shadowDataRunCreateDataRequest'
import type {
  ShadowDataRunDownloadDataRequest
} from '../../model/shadowDataRunDownloadDataRequest'
import type {
  UserReadDataList
} from '../../model/userReadDataList'
import type {
  UserRoleUpdateAPIDataRequest
} from '../../model/userRoleUpdateAPIDataRequest'
import type {
  UsersInternalTableDataRetrieveParams
} from '../../model/usersInternalTableDataRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets the audit table data
 */
export const internalAuditLogTableRetrieve = (
    auditLogTableQueryDataRequest: AuditLogTableQueryDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/audit-log/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: auditLogTableQueryDataRequest
    },
      options);
    }
  


export const getInternalAuditLogTableRetrieveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalAuditLogTableRetrieve>>, TError,{data: AuditLogTableQueryDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalAuditLogTableRetrieve>>, TError,{data: AuditLogTableQueryDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalAuditLogTableRetrieve>>, {data: AuditLogTableQueryDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalAuditLogTableRetrieve(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalAuditLogTableRetrieveMutationResult = NonNullable<Awaited<ReturnType<typeof internalAuditLogTableRetrieve>>>
    export type InternalAuditLogTableRetrieveMutationBody = AuditLogTableQueryDataRequest
    export type InternalAuditLogTableRetrieveMutationError = unknown

    export const useInternalAuditLogTableRetrieve = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalAuditLogTableRetrieve>>, TError,{data: AuditLogTableQueryDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalAuditLogTableRetrieveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the operation ids to filter on
 */
export const internalAuditLogFilterDataRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AuditLogTableFilterData>(
      {url: `/internal/audit-log-operation-ids/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalAuditLogFilterDataRetrieveQueryKey = () => {
    return [`/internal/audit-log-operation-ids/`] as const;
    }

    
export const getInternalAuditLogFilterDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalAuditLogFilterDataRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>> = ({ signal }) => internalAuditLogFilterDataRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalAuditLogFilterDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>>
export type InternalAuditLogFilterDataRetrieveQueryError = unknown

export const useInternalAuditLogFilterDataRetrieve = <TData = Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalAuditLogFilterDataRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalAuditLogFilterDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalAuditLogFilterDataRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>> = ({ signal }) => internalAuditLogFilterDataRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalAuditLogFilterDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>>
export type InternalAuditLogFilterDataRetrieveSuspenseQueryError = unknown

export const useInternalAuditLogFilterDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAuditLogFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalAuditLogFilterDataRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalAuditLogFilterDataRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalAuditLogFilterDataRetrieveQueryKey(),
          queryFn: () => internalAuditLogFilterDataRetrieve(),
        }).then(() => null));
      /**
 * Gets the audit log data for a particular request
 */
export const internalModelAuditLogEntriesList = (
    apiAuditLogEntryId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ModelAuditLogEntryReadDataList>(
      {url: `/internal/audit-log/${apiAuditLogEntryId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalModelAuditLogEntriesListQueryKey = (apiAuditLogEntryId: string,) => {
    return [`/internal/audit-log/${apiAuditLogEntryId}/`] as const;
    }

    
export const getInternalModelAuditLogEntriesListQueryOptions = <TData = Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError = unknown>(apiAuditLogEntryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalModelAuditLogEntriesListQueryKey(apiAuditLogEntryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>> = ({ signal }) => internalModelAuditLogEntriesList(apiAuditLogEntryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(apiAuditLogEntryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalModelAuditLogEntriesListQueryResult = NonNullable<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>>
export type InternalModelAuditLogEntriesListQueryError = unknown

export const useInternalModelAuditLogEntriesList = <TData = Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError = unknown>(
 apiAuditLogEntryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalModelAuditLogEntriesListQueryOptions(apiAuditLogEntryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalModelAuditLogEntriesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError = unknown>(apiAuditLogEntryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalModelAuditLogEntriesListQueryKey(apiAuditLogEntryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>> = ({ signal }) => internalModelAuditLogEntriesList(apiAuditLogEntryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(apiAuditLogEntryId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalModelAuditLogEntriesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>>
export type InternalModelAuditLogEntriesListSuspenseQueryError = unknown

export const useInternalModelAuditLogEntriesListSuspense = <TData = Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError = unknown>(
 apiAuditLogEntryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalModelAuditLogEntriesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalModelAuditLogEntriesListSuspenseQueryOptions(apiAuditLogEntryId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalModelAuditLogEntriesListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ apiAuditLogEntryId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { apiAuditLogEntryId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (apiAuditLogEntryId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalModelAuditLogEntriesListQueryKey(apiAuditLogEntryId),
              queryFn: () => internalModelAuditLogEntriesList(apiAuditLogEntryId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Lists all customers
 */
export const internalCustomerList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerDataList>(
      {url: `/internal/customer/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalCustomerListQueryKey = () => {
    return [`/internal/customer/`] as const;
    }

    
export const getInternalCustomerListQueryOptions = <TData = Awaited<ReturnType<typeof internalCustomerList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalCustomerList>>> = ({ signal }) => internalCustomerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalCustomerListQueryResult = NonNullable<Awaited<ReturnType<typeof internalCustomerList>>>
export type InternalCustomerListQueryError = unknown

export const useInternalCustomerList = <TData = Awaited<ReturnType<typeof internalCustomerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalCustomerListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalCustomerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalCustomerList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalCustomerList>>> = ({ signal }) => internalCustomerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalCustomerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalCustomerList>>>
export type InternalCustomerListSuspenseQueryError = unknown

export const useInternalCustomerListSuspense = <TData = Awaited<ReturnType<typeof internalCustomerList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalCustomerListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalCustomerListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalCustomerListQueryKey(),
          queryFn: () => internalCustomerList(),
        }).then(() => null));
      /**
 * Lists table data of all customers
 */
export const internalProvisioningCustomersTableDataRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/customer-table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalProvisioningCustomersTableDataRetrieveQueryKey = () => {
    return [`/internal/customer-table-data/`] as const;
    }

    
export const getInternalProvisioningCustomersTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalProvisioningCustomersTableDataRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>> = ({ signal }) => internalProvisioningCustomersTableDataRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalProvisioningCustomersTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>>
export type InternalProvisioningCustomersTableDataRetrieveQueryError = unknown

export const useInternalProvisioningCustomersTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalProvisioningCustomersTableDataRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalProvisioningCustomersTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalProvisioningCustomersTableDataRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>> = ({ signal }) => internalProvisioningCustomersTableDataRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalProvisioningCustomersTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>>
export type InternalProvisioningCustomersTableDataRetrieveSuspenseQueryError = unknown

export const useInternalProvisioningCustomersTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomersTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalProvisioningCustomersTableDataRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalProvisioningCustomersTableDataRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalProvisioningCustomersTableDataRetrieveQueryKey(),
          queryFn: () => internalProvisioningCustomersTableDataRetrieve(),
        }).then(() => null));
      /**
 * Gets users grouped by customer table data.
 */
export const internalProvisioningCustomerUserRelationsTableDataRetrieve = (
    customerId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/customer-user-relations/${customerId}/user-table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryKey = (customerId: string,) => {
    return [`/internal/customer-user-relations/${customerId}/user-table-data/`] as const;
    }

    
export const getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>> = ({ signal }) => internalProvisioningCustomerUserRelationsTableDataRetrieve(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalProvisioningCustomerUserRelationsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>>
export type InternalProvisioningCustomerUserRelationsTableDataRetrieveQueryError = unknown

export const useInternalProvisioningCustomerUserRelationsTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryOptions(customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalProvisioningCustomerUserRelationsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>> = ({ signal }) => internalProvisioningCustomerUserRelationsTableDataRetrieve(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalProvisioningCustomerUserRelationsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>>
export type InternalProvisioningCustomerUserRelationsTableDataRetrieveSuspenseQueryError = unknown

export const useInternalProvisioningCustomerUserRelationsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalProvisioningCustomerUserRelationsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalProvisioningCustomerUserRelationsTableDataRetrieveSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalProvisioningCustomerUserRelationsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalProvisioningCustomerUserRelationsTableDataRetrieveQueryKey(customerId),
              queryFn: () => internalProvisioningCustomerUserRelationsTableDataRetrieve(customerId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get internal customer
 */
export const internalCustomerRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerData>(
      {url: `/internal/customer/instance/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalCustomerRetrieveQueryKey = () => {
    return [`/internal/customer/instance/`] as const;
    }

    
export const getInternalCustomerRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalCustomerRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalCustomerRetrieve>>> = ({ signal }) => internalCustomerRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalCustomerRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalCustomerRetrieve>>>
export type InternalCustomerRetrieveQueryError = unknown

export const useInternalCustomerRetrieve = <TData = Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalCustomerRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalCustomerRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalCustomerRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalCustomerRetrieve>>> = ({ signal }) => internalCustomerRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalCustomerRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalCustomerRetrieve>>>
export type InternalCustomerRetrieveSuspenseQueryError = unknown

export const useInternalCustomerRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalCustomerRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalCustomerRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalCustomerRetrieveQueryKey(),
          queryFn: () => internalCustomerRetrieve(),
        }).then(() => null));
      /**
 * Creates internal event export
 */
export const internalEventExportCreate = (
    eventExportCreateDataRequest: EventExportCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<EventImportExportReadData>(
      {url: `/internal/event-export/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventExportCreateDataRequest
    },
      options);
    }
  


export const getInternalEventExportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventExportCreate>>, TError,{data: EventExportCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventExportCreate>>, TError,{data: EventExportCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventExportCreate>>, {data: EventExportCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalEventExportCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventExportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventExportCreate>>>
    export type InternalEventExportCreateMutationBody = EventExportCreateDataRequest
    export type InternalEventExportCreateMutationError = unknown

    export const useInternalEventExportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventExportCreate>>, TError,{data: EventExportCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventExportCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates internal event import
 */
export const internalEventImportCreate = (
    eventImportCreateAPIDataRequest: EventImportCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<EventImportExportReadData>(
      {url: `/internal/event-import/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventImportCreateAPIDataRequest
    },
      options);
    }
  


export const getInternalEventImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventImportCreate>>, TError,{data: EventImportCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventImportCreate>>, TError,{data: EventImportCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventImportCreate>>, {data: EventImportCreateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalEventImportCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventImportCreate>>>
    export type InternalEventImportCreateMutationBody = EventImportCreateAPIDataRequest
    export type InternalEventImportCreateMutationError = unknown

    export const useInternalEventImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventImportCreate>>, TError,{data: EventImportCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventImportCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets internal event import export table data
 */
export const internalEventImportExportTableDataRetrieve = (
    params: InternalEventImportExportTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/event-import-export-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalEventImportExportTableDataRetrieveQueryKey = (params: InternalEventImportExportTableDataRetrieveParams,) => {
    return [`/internal/event-import-export-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalEventImportExportTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError = unknown>(params: InternalEventImportExportTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>> = ({ signal }) => internalEventImportExportTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>>
export type InternalEventImportExportTableDataRetrieveQueryError = unknown

export const useInternalEventImportExportTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError = unknown>(
 params: InternalEventImportExportTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportTableDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventImportExportTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError = unknown>(params: InternalEventImportExportTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>> = ({ signal }) => internalEventImportExportTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>>
export type InternalEventImportExportTableDataRetrieveSuspenseQueryError = unknown

export const useInternalEventImportExportTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError = unknown>(
 params: InternalEventImportExportTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportTableDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventImportExportTableDataRetrieveLoader = (queryParamsOrFn: (InternalEventImportExportTableDataRetrieveParams | ((params: Params) => InternalEventImportExportTableDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getInternalEventImportExportTableDataRetrieveQueryKey(queryParams),
            queryFn: () => internalEventImportExportTableDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Gets internal event import export data
 */
export const internalEventImportExportRetrieve = (
    eventImportExportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventImportExportReadData>(
      {url: `/internal/event-import-export/${eventImportExportId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventImportExportRetrieveQueryKey = (eventImportExportId: string,) => {
    return [`/internal/event-import-export/${eventImportExportId}/`] as const;
    }

    
export const getInternalEventImportExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>> = ({ signal }) => internalEventImportExportRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>>
export type InternalEventImportExportRetrieveQueryError = unknown

export const useInternalEventImportExportRetrieve = <TData = Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportRetrieveQueryOptions(eventImportExportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventImportExportRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>> = ({ signal }) => internalEventImportExportRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>>
export type InternalEventImportExportRetrieveSuspenseQueryError = unknown

export const useInternalEventImportExportRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportRetrieveSuspenseQueryOptions(eventImportExportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventImportExportRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventImportExportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventImportExportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventImportExportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventImportExportRetrieveQueryKey(eventImportExportId),
              queryFn: () => internalEventImportExportRetrieve(eventImportExportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets stats for an event load
 */
export const internalEventImportExportLoadStatsRetrieve = (
    eventImportExportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventStatsData>(
      {url: `/internal/event-import-export/${eventImportExportId}/load-stats/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventImportExportLoadStatsRetrieveQueryKey = (eventImportExportId: string,) => {
    return [`/internal/event-import-export/${eventImportExportId}/load-stats/`] as const;
    }

    
export const getInternalEventImportExportLoadStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportLoadStatsRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>> = ({ signal }) => internalEventImportExportLoadStatsRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportLoadStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>>
export type InternalEventImportExportLoadStatsRetrieveQueryError = unknown

export const useInternalEventImportExportLoadStatsRetrieve = <TData = Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportLoadStatsRetrieveQueryOptions(eventImportExportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventImportExportLoadStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportLoadStatsRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>> = ({ signal }) => internalEventImportExportLoadStatsRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportLoadStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>>
export type InternalEventImportExportLoadStatsRetrieveSuspenseQueryError = unknown

export const useInternalEventImportExportLoadStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportLoadStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportLoadStatsRetrieveSuspenseQueryOptions(eventImportExportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventImportExportLoadStatsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventImportExportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventImportExportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventImportExportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventImportExportLoadStatsRetrieveQueryKey(eventImportExportId),
              queryFn: () => internalEventImportExportLoadStatsRetrieve(eventImportExportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets internal event import export records table data
 */
export const internalEventImportExportRecordsTableDataRetrieve = (
    eventImportExportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/event-import-export/${eventImportExportId}/record-table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventImportExportRecordsTableDataRetrieveQueryKey = (eventImportExportId: string,) => {
    return [`/internal/event-import-export/${eventImportExportId}/record-table-data/`] as const;
    }

    
export const getInternalEventImportExportRecordsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportRecordsTableDataRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>> = ({ signal }) => internalEventImportExportRecordsTableDataRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportRecordsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>>
export type InternalEventImportExportRecordsTableDataRetrieveQueryError = unknown

export const useInternalEventImportExportRecordsTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportRecordsTableDataRetrieveQueryOptions(eventImportExportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventImportExportRecordsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventImportExportRecordsTableDataRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>> = ({ signal }) => internalEventImportExportRecordsTableDataRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventImportExportRecordsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>>
export type InternalEventImportExportRecordsTableDataRetrieveSuspenseQueryError = unknown

export const useInternalEventImportExportRecordsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventImportExportRecordsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventImportExportRecordsTableDataRetrieveSuspenseQueryOptions(eventImportExportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventImportExportRecordsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventImportExportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventImportExportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventImportExportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventImportExportRecordsTableDataRetrieveQueryKey(eventImportExportId),
              queryFn: () => internalEventImportExportRecordsTableDataRetrieve(eventImportExportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets internal event template export record create data
 */
export const internalEventTemplateExportRecordCreateDataRetrieve = (
    eventImportExportId: string,
    eventTemplateExportRecordId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ExportCustomerEventJsonRecordReadData>(
      {url: `/internal/event-import-export/${eventImportExportId}/record/${eventTemplateExportRecordId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventTemplateExportRecordCreateDataRetrieveQueryKey = (eventImportExportId: string,
    eventTemplateExportRecordId: string,) => {
    return [`/internal/event-import-export/${eventImportExportId}/record/${eventTemplateExportRecordId}/`] as const;
    }

    
export const getInternalEventTemplateExportRecordCreateDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError = unknown>(eventImportExportId: string,
    eventTemplateExportRecordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateExportRecordCreateDataRetrieveQueryKey(eventImportExportId,eventTemplateExportRecordId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>> = ({ signal }) => internalEventTemplateExportRecordCreateDataRetrieve(eventImportExportId,eventTemplateExportRecordId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId && eventTemplateExportRecordId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateExportRecordCreateDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>>
export type InternalEventTemplateExportRecordCreateDataRetrieveQueryError = unknown

export const useInternalEventTemplateExportRecordCreateDataRetrieve = <TData = Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError = unknown>(
 eventImportExportId: string,
    eventTemplateExportRecordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateExportRecordCreateDataRetrieveQueryOptions(eventImportExportId,eventTemplateExportRecordId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateExportRecordCreateDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError = unknown>(eventImportExportId: string,
    eventTemplateExportRecordId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateExportRecordCreateDataRetrieveQueryKey(eventImportExportId,eventTemplateExportRecordId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>> = ({ signal }) => internalEventTemplateExportRecordCreateDataRetrieve(eventImportExportId,eventTemplateExportRecordId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId && eventTemplateExportRecordId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateExportRecordCreateDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>>
export type InternalEventTemplateExportRecordCreateDataRetrieveSuspenseQueryError = unknown

export const useInternalEventTemplateExportRecordCreateDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError = unknown>(
 eventImportExportId: string,
    eventTemplateExportRecordId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateExportRecordCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateExportRecordCreateDataRetrieveSuspenseQueryOptions(eventImportExportId,eventTemplateExportRecordId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateExportRecordCreateDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventImportExportId: string,eventTemplateExportRecordId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventImportExportId,eventTemplateExportRecordId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventImportExportId && eventTemplateExportRecordId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventTemplateExportRecordCreateDataRetrieveQueryKey(eventImportExportId,eventTemplateExportRecordId),
              queryFn: () => internalEventTemplateExportRecordCreateDataRetrieve(eventImportExportId,eventTemplateExportRecordId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates internal event load into a customer
 */
export const internalEventLoadCreate = (
    eventLoadCreateAPIDataRequest: EventLoadCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<EventImportExportReadData>(
      {url: `/internal/event-load/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventLoadCreateAPIDataRequest
    },
      options);
    }
  


export const getInternalEventLoadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventLoadCreate>>, TError,{data: EventLoadCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventLoadCreate>>, TError,{data: EventLoadCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventLoadCreate>>, {data: EventLoadCreateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalEventLoadCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventLoadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventLoadCreate>>>
    export type InternalEventLoadCreateMutationBody = EventLoadCreateAPIDataRequest
    export type InternalEventLoadCreateMutationError = unknown

    export const useInternalEventLoadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventLoadCreate>>, TError,{data: EventLoadCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventLoadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List internal load events checkpoint statuses
 */
export const internalLoadEventCheckpointStatusesRetrieve = (
    eventImportExportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<LoadEventCheckpointStatusData>(
      {url: `/internal/event-load/${eventImportExportId}/checkpoints/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalLoadEventCheckpointStatusesRetrieveQueryKey = (eventImportExportId: string,) => {
    return [`/internal/event-load/${eventImportExportId}/checkpoints/`] as const;
    }

    
export const getInternalLoadEventCheckpointStatusesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalLoadEventCheckpointStatusesRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>> = ({ signal }) => internalLoadEventCheckpointStatusesRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalLoadEventCheckpointStatusesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>>
export type InternalLoadEventCheckpointStatusesRetrieveQueryError = unknown

export const useInternalLoadEventCheckpointStatusesRetrieve = <TData = Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalLoadEventCheckpointStatusesRetrieveQueryOptions(eventImportExportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalLoadEventCheckpointStatusesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError = unknown>(eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalLoadEventCheckpointStatusesRetrieveQueryKey(eventImportExportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>> = ({ signal }) => internalLoadEventCheckpointStatusesRetrieve(eventImportExportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventImportExportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalLoadEventCheckpointStatusesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>>
export type InternalLoadEventCheckpointStatusesRetrieveSuspenseQueryError = unknown

export const useInternalLoadEventCheckpointStatusesRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError = unknown>(
 eventImportExportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointStatusesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalLoadEventCheckpointStatusesRetrieveSuspenseQueryOptions(eventImportExportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalLoadEventCheckpointStatusesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventImportExportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventImportExportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventImportExportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalLoadEventCheckpointStatusesRetrieveQueryKey(eventImportExportId),
              queryFn: () => internalLoadEventCheckpointStatusesRetrieve(eventImportExportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edit internal load events checkpoints
 */
export const internalLoadEventCheckpointUpdate = (
    eventImportExportId: string,
    loadEventCheckpointStatusDataRequest: LoadEventCheckpointStatusDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/event-load/${eventImportExportId}/checkpoints/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loadEventCheckpointStatusDataRequest
    },
      options);
    }
  


export const getInternalLoadEventCheckpointUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointUpdate>>, TError,{eventImportExportId: string;data: LoadEventCheckpointStatusDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointUpdate>>, TError,{eventImportExportId: string;data: LoadEventCheckpointStatusDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLoadEventCheckpointUpdate>>, {eventImportExportId: string;data: LoadEventCheckpointStatusDataRequest}> = (props) => {
          const {eventImportExportId,data} = props ?? {};

          return  internalLoadEventCheckpointUpdate(eventImportExportId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalLoadEventCheckpointUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalLoadEventCheckpointUpdate>>>
    export type InternalLoadEventCheckpointUpdateMutationBody = LoadEventCheckpointStatusDataRequest
    export type InternalLoadEventCheckpointUpdateMutationError = unknown

    export const useInternalLoadEventCheckpointUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLoadEventCheckpointUpdate>>, TError,{eventImportExportId: string;data: LoadEventCheckpointStatusDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalLoadEventCheckpointUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Continues internal event load into a customer
 */
export const internalContinueEventLoadCreate = (
    eventImportExportId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<EventImportExportReadData>(
      {url: `/internal/event-load/${eventImportExportId}/continue/`, method: 'POST'
    },
      options);
    }
  


export const getInternalContinueEventLoadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalContinueEventLoadCreate>>, TError,{eventImportExportId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalContinueEventLoadCreate>>, TError,{eventImportExportId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalContinueEventLoadCreate>>, {eventImportExportId: string}> = (props) => {
          const {eventImportExportId} = props ?? {};

          return  internalContinueEventLoadCreate(eventImportExportId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalContinueEventLoadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalContinueEventLoadCreate>>>
    
    export type InternalContinueEventLoadCreateMutationError = unknown

    export const useInternalContinueEventLoadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalContinueEventLoadCreate>>, TError,{eventImportExportId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalContinueEventLoadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get feature flag customer table data.
 */
export const internalFeatureFlagCustomerTableDataRetrieve = (
    featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/feature-flag/${featureFlagId}/customer-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalFeatureFlagCustomerTableDataRetrieveQueryKey = (featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams,) => {
    return [`/internal/feature-flag/${featureFlagId}/customer-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalFeatureFlagCustomerTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError = unknown>(featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFeatureFlagCustomerTableDataRetrieveQueryKey(featureFlagId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>> = ({ signal }) => internalFeatureFlagCustomerTableDataRetrieve(featureFlagId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFeatureFlagCustomerTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>>
export type InternalFeatureFlagCustomerTableDataRetrieveQueryError = unknown

export const useInternalFeatureFlagCustomerTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError = unknown>(
 featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFeatureFlagCustomerTableDataRetrieveQueryOptions(featureFlagId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalFeatureFlagCustomerTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError = unknown>(featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFeatureFlagCustomerTableDataRetrieveQueryKey(featureFlagId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>> = ({ signal }) => internalFeatureFlagCustomerTableDataRetrieve(featureFlagId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFeatureFlagCustomerTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>>
export type InternalFeatureFlagCustomerTableDataRetrieveSuspenseQueryError = unknown

export const useInternalFeatureFlagCustomerTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError = unknown>(
 featureFlagId: string,
    params?: InternalFeatureFlagCustomerTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagCustomerTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFeatureFlagCustomerTableDataRetrieveSuspenseQueryOptions(featureFlagId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalFeatureFlagCustomerTableDataRetrieveLoader = (queryParamsOrFn?: (InternalFeatureFlagCustomerTableDataRetrieveParams | ((params: Params) => InternalFeatureFlagCustomerTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ featureFlagId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { featureFlagId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (featureFlagId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalFeatureFlagCustomerTableDataRetrieveQueryKey(featureFlagId, queryParams),
              queryFn: () => internalFeatureFlagCustomerTableDataRetrieve(featureFlagId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get feature flag user table data.
 */
export const internalFeatureFlagUserTableDataRetrieve = (
    featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/feature-flag/${featureFlagId}/user-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalFeatureFlagUserTableDataRetrieveQueryKey = (featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams,) => {
    return [`/internal/feature-flag/${featureFlagId}/user-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalFeatureFlagUserTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError = unknown>(featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFeatureFlagUserTableDataRetrieveQueryKey(featureFlagId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>> = ({ signal }) => internalFeatureFlagUserTableDataRetrieve(featureFlagId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFeatureFlagUserTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>>
export type InternalFeatureFlagUserTableDataRetrieveQueryError = unknown

export const useInternalFeatureFlagUserTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError = unknown>(
 featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFeatureFlagUserTableDataRetrieveQueryOptions(featureFlagId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalFeatureFlagUserTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError = unknown>(featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFeatureFlagUserTableDataRetrieveQueryKey(featureFlagId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>> = ({ signal }) => internalFeatureFlagUserTableDataRetrieve(featureFlagId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFeatureFlagUserTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>>
export type InternalFeatureFlagUserTableDataRetrieveSuspenseQueryError = unknown

export const useInternalFeatureFlagUserTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError = unknown>(
 featureFlagId: string,
    params?: InternalFeatureFlagUserTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFeatureFlagUserTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFeatureFlagUserTableDataRetrieveSuspenseQueryOptions(featureFlagId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalFeatureFlagUserTableDataRetrieveLoader = (queryParamsOrFn?: (InternalFeatureFlagUserTableDataRetrieveParams | ((params: Params) => InternalFeatureFlagUserTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ featureFlagId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { featureFlagId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (featureFlagId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalFeatureFlagUserTableDataRetrieveQueryKey(featureFlagId, queryParams),
              queryFn: () => internalFeatureFlagUserTableDataRetrieve(featureFlagId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * This endpoint edits a specific environment level feature flag.
 */
export const internalFeatureFlagUpdate = (
    featureFlagId: string,
    internalFeatureFlagEditDataRequest: InternalFeatureFlagEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeatureFlagReadData>(
      {url: `/internal/feature-flags/${featureFlagId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: internalFeatureFlagEditDataRequest
    },
      options);
    }
  


export const getInternalFeatureFlagUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalFeatureFlagUpdate>>, TError,{featureFlagId: string;data: InternalFeatureFlagEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalFeatureFlagUpdate>>, TError,{featureFlagId: string;data: InternalFeatureFlagEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalFeatureFlagUpdate>>, {featureFlagId: string;data: InternalFeatureFlagEditDataRequest}> = (props) => {
          const {featureFlagId,data} = props ?? {};

          return  internalFeatureFlagUpdate(featureFlagId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalFeatureFlagUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalFeatureFlagUpdate>>>
    export type InternalFeatureFlagUpdateMutationBody = InternalFeatureFlagEditDataRequest
    export type InternalFeatureFlagUpdateMutationError = unknown

    export const useInternalFeatureFlagUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalFeatureFlagUpdate>>, TError,{featureFlagId: string;data: InternalFeatureFlagEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalFeatureFlagUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the available fund families for a given customer name
 */
export const internalFundFamilySelectOptionsForComparisonList = (
    customerId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/internal/fund-family-select-options-for-comparison/${customerId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalFundFamilySelectOptionsForComparisonListQueryKey = (customerId: string,) => {
    return [`/internal/fund-family-select-options-for-comparison/${customerId}/`] as const;
    }

    
export const getInternalFundFamilySelectOptionsForComparisonListQueryOptions = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFundFamilySelectOptionsForComparisonListQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>> = ({ signal }) => internalFundFamilySelectOptionsForComparisonList(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFundFamilySelectOptionsForComparisonListQueryResult = NonNullable<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>>
export type InternalFundFamilySelectOptionsForComparisonListQueryError = unknown

export const useInternalFundFamilySelectOptionsForComparisonList = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFundFamilySelectOptionsForComparisonListQueryOptions(customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalFundFamilySelectOptionsForComparisonListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFundFamilySelectOptionsForComparisonListQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>> = ({ signal }) => internalFundFamilySelectOptionsForComparisonList(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFundFamilySelectOptionsForComparisonListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>>
export type InternalFundFamilySelectOptionsForComparisonListSuspenseQueryError = unknown

export const useInternalFundFamilySelectOptionsForComparisonListSuspense = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsForComparisonList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFundFamilySelectOptionsForComparisonListSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalFundFamilySelectOptionsForComparisonListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalFundFamilySelectOptionsForComparisonListQueryKey(customerId),
              queryFn: () => internalFundFamilySelectOptionsForComparisonList(customerId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets the available fund families for a given customer ID
 */
export const internalFundFamilySelectOptionsList = (
    customerId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/internal/fund-family-select-options/${customerId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalFundFamilySelectOptionsListQueryKey = (customerId: string,) => {
    return [`/internal/fund-family-select-options/${customerId}/`] as const;
    }

    
export const getInternalFundFamilySelectOptionsListQueryOptions = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFundFamilySelectOptionsListQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>> = ({ signal }) => internalFundFamilySelectOptionsList(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFundFamilySelectOptionsListQueryResult = NonNullable<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>>
export type InternalFundFamilySelectOptionsListQueryError = unknown

export const useInternalFundFamilySelectOptionsList = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFundFamilySelectOptionsListQueryOptions(customerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalFundFamilySelectOptionsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalFundFamilySelectOptionsListQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>> = ({ signal }) => internalFundFamilySelectOptionsList(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalFundFamilySelectOptionsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>>
export type InternalFundFamilySelectOptionsListSuspenseQueryError = unknown

export const useInternalFundFamilySelectOptionsListSuspense = <TData = Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalFundFamilySelectOptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalFundFamilySelectOptionsListSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalFundFamilySelectOptionsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalFundFamilySelectOptionsListQueryKey(customerId),
              queryFn: () => internalFundFamilySelectOptionsList(customerId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * All data runs for the current user
 */
export const internalShadowDataRunTableDataRetrieve = (
    params?: InternalShadowDataRunTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/shadow-data-run/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalShadowDataRunTableDataRetrieveQueryKey = (params?: InternalShadowDataRunTableDataRetrieveParams,) => {
    return [`/internal/shadow-data-run/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalShadowDataRunTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError = unknown>(params?: InternalShadowDataRunTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalShadowDataRunTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>> = ({ signal }) => internalShadowDataRunTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalShadowDataRunTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>>
export type InternalShadowDataRunTableDataRetrieveQueryError = unknown

export const useInternalShadowDataRunTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError = unknown>(
 params?: InternalShadowDataRunTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalShadowDataRunTableDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalShadowDataRunTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError = unknown>(params?: InternalShadowDataRunTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalShadowDataRunTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>> = ({ signal }) => internalShadowDataRunTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalShadowDataRunTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>>
export type InternalShadowDataRunTableDataRetrieveSuspenseQueryError = unknown

export const useInternalShadowDataRunTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError = unknown>(
 params?: InternalShadowDataRunTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalShadowDataRunTableDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalShadowDataRunTableDataRetrieveLoader = (queryParamsOrFn?: (InternalShadowDataRunTableDataRetrieveParams | ((params: Params) => InternalShadowDataRunTableDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getInternalShadowDataRunTableDataRetrieveQueryKey(queryParams),
            queryFn: () => internalShadowDataRunTableDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Create shadow data run
 */
export const internalShadowDataRunCreate = (
    shadowDataRunCreateDataRequest: ShadowDataRunCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<MuuidData>(
      {url: `/internal/shadow-data-run/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shadowDataRunCreateDataRequest
    },
      options);
    }
  


export const getInternalShadowDataRunCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunCreate>>, TError,{data: ShadowDataRunCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunCreate>>, TError,{data: ShadowDataRunCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalShadowDataRunCreate>>, {data: ShadowDataRunCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalShadowDataRunCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalShadowDataRunCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunCreate>>>
    export type InternalShadowDataRunCreateMutationBody = ShadowDataRunCreateDataRequest
    export type InternalShadowDataRunCreateMutationError = unknown

    export const useInternalShadowDataRunCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunCreate>>, TError,{data: ShadowDataRunCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalShadowDataRunCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get details for a single data run
 */
export const internalShadowDataRunStatusTableDataRetrieve = (
    dataRunId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/shadow-data-run/${dataRunId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalShadowDataRunStatusTableDataRetrieveQueryKey = (dataRunId: string,) => {
    return [`/internal/shadow-data-run/${dataRunId}/`] as const;
    }

    
export const getInternalShadowDataRunStatusTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError = unknown>(dataRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalShadowDataRunStatusTableDataRetrieveQueryKey(dataRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>> = ({ signal }) => internalShadowDataRunStatusTableDataRetrieve(dataRunId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dataRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalShadowDataRunStatusTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>>
export type InternalShadowDataRunStatusTableDataRetrieveQueryError = unknown

export const useInternalShadowDataRunStatusTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError = unknown>(
 dataRunId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalShadowDataRunStatusTableDataRetrieveQueryOptions(dataRunId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalShadowDataRunStatusTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError = unknown>(dataRunId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalShadowDataRunStatusTableDataRetrieveQueryKey(dataRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>> = ({ signal }) => internalShadowDataRunStatusTableDataRetrieve(dataRunId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dataRunId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalShadowDataRunStatusTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>>
export type InternalShadowDataRunStatusTableDataRetrieveSuspenseQueryError = unknown

export const useInternalShadowDataRunStatusTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError = unknown>(
 dataRunId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalShadowDataRunStatusTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalShadowDataRunStatusTableDataRetrieveSuspenseQueryOptions(dataRunId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalShadowDataRunStatusTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ dataRunId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { dataRunId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (dataRunId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalShadowDataRunStatusTableDataRetrieveQueryKey(dataRunId),
              queryFn: () => internalShadowDataRunStatusTableDataRetrieve(dataRunId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Process shadow data run
 */
export const internalShadowDataRunProcess = (
    dataRunId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/shadow-data-run/${dataRunId}/`, method: 'POST'
    },
      options);
    }
  


export const getInternalShadowDataRunProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunProcess>>, TError,{dataRunId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunProcess>>, TError,{dataRunId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalShadowDataRunProcess>>, {dataRunId: string}> = (props) => {
          const {dataRunId} = props ?? {};

          return  internalShadowDataRunProcess(dataRunId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalShadowDataRunProcessMutationResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunProcess>>>
    
    export type InternalShadowDataRunProcessMutationError = unknown

    export const useInternalShadowDataRunProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunProcess>>, TError,{dataRunId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalShadowDataRunProcessMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a shadow data run.
 */
export const internalShadowDataRunDelete = (
    dataRunId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/shadow-data-run/${dataRunId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getInternalShadowDataRunDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDelete>>, TError,{dataRunId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDelete>>, TError,{dataRunId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalShadowDataRunDelete>>, {dataRunId: string}> = (props) => {
          const {dataRunId} = props ?? {};

          return  internalShadowDataRunDelete(dataRunId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalShadowDataRunDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunDelete>>>
    
    export type InternalShadowDataRunDeleteMutationError = unknown

    export const useInternalShadowDataRunDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDelete>>, TError,{dataRunId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalShadowDataRunDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Downloads a shadow data file
 */
export const internalShadowDataRunDownload = (
    dataRunId: string,
    shadowDataRunDownloadDataRequest: ShadowDataRunDownloadDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<Blob>(
      {url: `/internal/shadow-data-run/${dataRunId}/download/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shadowDataRunDownloadDataRequest,
        responseType: 'blob'
    },
      options);
    }
  


export const getInternalShadowDataRunDownloadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDownload>>, TError,{dataRunId: string;data: ShadowDataRunDownloadDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDownload>>, TError,{dataRunId: string;data: ShadowDataRunDownloadDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalShadowDataRunDownload>>, {dataRunId: string;data: ShadowDataRunDownloadDataRequest}> = (props) => {
          const {dataRunId,data} = props ?? {};

          return  internalShadowDataRunDownload(dataRunId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalShadowDataRunDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof internalShadowDataRunDownload>>>
    export type InternalShadowDataRunDownloadMutationBody = ShadowDataRunDownloadDataRequest
    export type InternalShadowDataRunDownloadMutationError = unknown

    export const useInternalShadowDataRunDownload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalShadowDataRunDownload>>, TError,{dataRunId: string;data: ShadowDataRunDownloadDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalShadowDataRunDownloadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get internal event template version
 */
export const internalEventTemplateVersionRetrieve = (
    eventTemplateVersionId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventTemplateReadData>(
      {url: `/internal/template-version/${eventTemplateVersionId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventTemplateVersionRetrieveQueryKey = (eventTemplateVersionId: string,) => {
    return [`/internal/template-version/${eventTemplateVersionId}/`] as const;
    }

    
export const getInternalEventTemplateVersionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError = unknown>(eventTemplateVersionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateVersionRetrieveQueryKey(eventTemplateVersionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>> = ({ signal }) => internalEventTemplateVersionRetrieve(eventTemplateVersionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateVersionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>>
export type InternalEventTemplateVersionRetrieveQueryError = unknown

export const useInternalEventTemplateVersionRetrieve = <TData = Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateVersionRetrieveQueryOptions(eventTemplateVersionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateVersionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError = unknown>(eventTemplateVersionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateVersionRetrieveQueryKey(eventTemplateVersionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>> = ({ signal }) => internalEventTemplateVersionRetrieve(eventTemplateVersionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateVersionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>>
export type InternalEventTemplateVersionRetrieveSuspenseQueryError = unknown

export const useInternalEventTemplateVersionRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateVersionRetrieveSuspenseQueryOptions(eventTemplateVersionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateVersionRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventTemplateVersionId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventTemplateVersionId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventTemplateVersionId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventTemplateVersionRetrieveQueryKey(eventTemplateVersionId),
              queryFn: () => internalEventTemplateVersionRetrieve(eventTemplateVersionId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Delete internal template events
 */
export const internalEventTemplateEventsDelete = (
    eventTemplateVersionId: string,
    eventTemplateEventDeleteDataRequest: EventTemplateEventDeleteDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/template-version/${eventTemplateVersionId}/delete-events/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventTemplateEventDeleteDataRequest
    },
      options);
    }
  


export const getInternalEventTemplateEventsDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventsDelete>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventDeleteDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventsDelete>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventDeleteDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventTemplateEventsDelete>>, {eventTemplateVersionId: string;data: EventTemplateEventDeleteDataRequest}> = (props) => {
          const {eventTemplateVersionId,data} = props ?? {};

          return  internalEventTemplateEventsDelete(eventTemplateVersionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventTemplateEventsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventsDelete>>>
    export type InternalEventTemplateEventsDeleteMutationBody = EventTemplateEventDeleteDataRequest
    export type InternalEventTemplateEventsDeleteMutationError = unknown

    export const useInternalEventTemplateEventsDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventsDelete>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventDeleteDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventTemplateEventsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets internal event template event data for a specific template version id
 */
export const internalEventTemplateEventTableDataRetrieve = (
    eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/template-version/${eventTemplateVersionId}/event-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalEventTemplateEventTableDataRetrieveQueryKey = (eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams,) => {
    return [`/internal/template-version/${eventTemplateVersionId}/event-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalEventTemplateEventTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError = unknown>(eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateEventTableDataRetrieveQueryKey(eventTemplateVersionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>> = ({ signal }) => internalEventTemplateEventTableDataRetrieve(eventTemplateVersionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateEventTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>>
export type InternalEventTemplateEventTableDataRetrieveQueryError = unknown

export const useInternalEventTemplateEventTableDataRetrieve = <TData = Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateEventTableDataRetrieveQueryOptions(eventTemplateVersionId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateEventTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError = unknown>(eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateEventTableDataRetrieveQueryKey(eventTemplateVersionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>> = ({ signal }) => internalEventTemplateEventTableDataRetrieve(eventTemplateVersionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateEventTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>>
export type InternalEventTemplateEventTableDataRetrieveSuspenseQueryError = unknown

export const useInternalEventTemplateEventTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string,
    params: InternalEventTemplateEventTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateEventTableDataRetrieveSuspenseQueryOptions(eventTemplateVersionId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateEventTableDataRetrieveLoader = (queryParamsOrFn: (InternalEventTemplateEventTableDataRetrieveParams | ((params: Params) => InternalEventTemplateEventTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ eventTemplateVersionId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventTemplateVersionId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (eventTemplateVersionId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventTemplateEventTableDataRetrieveQueryKey(eventTemplateVersionId, queryParams),
              queryFn: () => internalEventTemplateEventTableDataRetrieve(eventTemplateVersionId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets internal event template object create data
 */
export const internalEventTemplateEventCreateDataRetrieve = (
    eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventTemplateEventJsonData>(
      {url: `/internal/template-version/${eventTemplateVersionId}/event/${eventTemplateEventId}/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalEventTemplateEventCreateDataRetrieveQueryKey = (eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams,) => {
    return [`/internal/template-version/${eventTemplateVersionId}/event/${eventTemplateEventId}/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalEventTemplateEventCreateDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError = unknown>(eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateEventCreateDataRetrieveQueryKey(eventTemplateVersionId,eventTemplateEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>> = ({ signal }) => internalEventTemplateEventCreateDataRetrieve(eventTemplateVersionId,eventTemplateEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId && eventTemplateEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateEventCreateDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>>
export type InternalEventTemplateEventCreateDataRetrieveQueryError = unknown

export const useInternalEventTemplateEventCreateDataRetrieve = <TData = Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateEventCreateDataRetrieveQueryOptions(eventTemplateVersionId,eventTemplateEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateEventCreateDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError = unknown>(eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateEventCreateDataRetrieveQueryKey(eventTemplateVersionId,eventTemplateEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>> = ({ signal }) => internalEventTemplateEventCreateDataRetrieve(eventTemplateVersionId,eventTemplateEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateVersionId && eventTemplateEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateEventCreateDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>>
export type InternalEventTemplateEventCreateDataRetrieveSuspenseQueryError = unknown

export const useInternalEventTemplateEventCreateDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError = unknown>(
 eventTemplateVersionId: string,
    eventTemplateEventId: string,
    params: InternalEventTemplateEventCreateDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateEventCreateDataRetrieveSuspenseQueryOptions(eventTemplateVersionId,eventTemplateEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateEventCreateDataRetrieveLoader = (queryParamsOrFn: (InternalEventTemplateEventCreateDataRetrieveParams | ((params: Params) => InternalEventTemplateEventCreateDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ eventTemplateVersionId: string,eventTemplateEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventTemplateVersionId,eventTemplateEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (eventTemplateVersionId && eventTemplateEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventTemplateEventCreateDataRetrieveQueryKey(eventTemplateVersionId,eventTemplateEventId, queryParams),
              queryFn: () => internalEventTemplateEventCreateDataRetrieve(eventTemplateVersionId,eventTemplateEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates internal event template object data
 */
export const internalEventTemplateEventUpdate = (
    eventTemplateVersionId: string,
    eventTemplateEventId: string,
    eventTemplateEventUpdateDataRequest: EventTemplateEventUpdateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/template-version/${eventTemplateVersionId}/event/${eventTemplateEventId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventTemplateEventUpdateDataRequest
    },
      options);
    }
  


export const getInternalEventTemplateEventUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventUpdate>>, TError,{eventTemplateVersionId: string;eventTemplateEventId: string;data: EventTemplateEventUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventUpdate>>, TError,{eventTemplateVersionId: string;eventTemplateEventId: string;data: EventTemplateEventUpdateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventTemplateEventUpdate>>, {eventTemplateVersionId: string;eventTemplateEventId: string;data: EventTemplateEventUpdateDataRequest}> = (props) => {
          const {eventTemplateVersionId,eventTemplateEventId,data} = props ?? {};

          return  internalEventTemplateEventUpdate(eventTemplateVersionId,eventTemplateEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventTemplateEventUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventUpdate>>>
    export type InternalEventTemplateEventUpdateMutationBody = EventTemplateEventUpdateDataRequest
    export type InternalEventTemplateEventUpdateMutationError = unknown

    export const useInternalEventTemplateEventUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventUpdate>>, TError,{eventTemplateVersionId: string;eventTemplateEventId: string;data: EventTemplateEventUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventTemplateEventUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Edit internal load event order
 */
export const internalEventTemplateEventOrderUpdate = (
    eventTemplateVersionId: string,
    eventTemplateEventOrderStatusDataRequest: EventTemplateEventOrderStatusDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/template-version/${eventTemplateVersionId}/order/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventTemplateEventOrderStatusDataRequest
    },
      options);
    }
  


export const getInternalEventTemplateEventOrderUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventOrderUpdate>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventOrderStatusDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventOrderUpdate>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventOrderStatusDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalEventTemplateEventOrderUpdate>>, {eventTemplateVersionId: string;data: EventTemplateEventOrderStatusDataRequest}> = (props) => {
          const {eventTemplateVersionId,data} = props ?? {};

          return  internalEventTemplateEventOrderUpdate(eventTemplateVersionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalEventTemplateEventOrderUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateEventOrderUpdate>>>
    export type InternalEventTemplateEventOrderUpdateMutationBody = EventTemplateEventOrderStatusDataRequest
    export type InternalEventTemplateEventOrderUpdateMutationError = unknown

    export const useInternalEventTemplateEventOrderUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalEventTemplateEventOrderUpdate>>, TError,{eventTemplateVersionId: string;data: EventTemplateEventOrderStatusDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalEventTemplateEventOrderUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get event temmplate
 */
export const internalEventTemplateRetrieve = (
    eventTemplateId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventTemplateReadData>(
      {url: `/internal/template/${eventTemplateId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventTemplateRetrieveQueryKey = (eventTemplateId: string,) => {
    return [`/internal/template/${eventTemplateId}/`] as const;
    }

    
export const getInternalEventTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError = unknown>(eventTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateRetrieveQueryKey(eventTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>> = ({ signal }) => internalEventTemplateRetrieve(eventTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>>
export type InternalEventTemplateRetrieveQueryError = unknown

export const useInternalEventTemplateRetrieve = <TData = Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError = unknown>(
 eventTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateRetrieveQueryOptions(eventTemplateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError = unknown>(eventTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateRetrieveQueryKey(eventTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>> = ({ signal }) => internalEventTemplateRetrieve(eventTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventTemplateId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>>
export type InternalEventTemplateRetrieveSuspenseQueryError = unknown

export const useInternalEventTemplateRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError = unknown>(
 eventTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateRetrieveSuspenseQueryOptions(eventTemplateId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ eventTemplateId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { eventTemplateId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (eventTemplateId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalEventTemplateRetrieveQueryKey(eventTemplateId),
              queryFn: () => internalEventTemplateRetrieve(eventTemplateId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List internal event templates
 */
export const internalEventTemplateList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<EventTemplateReadDataList>(
      {url: `/internal/templates/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalEventTemplateListQueryKey = () => {
    return [`/internal/templates/`] as const;
    }

    
export const getInternalEventTemplateListQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateList>>> = ({ signal }) => internalEventTemplateList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateListQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateList>>>
export type InternalEventTemplateListQueryError = unknown

export const useInternalEventTemplateList = <TData = Awaited<ReturnType<typeof internalEventTemplateList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalEventTemplateListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalEventTemplateList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalEventTemplateListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalEventTemplateList>>> = ({ signal }) => internalEventTemplateList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalEventTemplateListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalEventTemplateList>>>
export type InternalEventTemplateListSuspenseQueryError = unknown

export const useInternalEventTemplateListSuspense = <TData = Awaited<ReturnType<typeof internalEventTemplateList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalEventTemplateList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalEventTemplateListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalEventTemplateListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalEventTemplateListQueryKey(),
          queryFn: () => internalEventTemplateList(),
        }).then(() => null));
      /**
 * Lists all users unrelated to a given customer.
 */
export const internalUnrelatedUserList = (
    params: InternalUnrelatedUserListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UserReadDataList>(
      {url: `/internal/users/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInternalUnrelatedUserListQueryKey = (params: InternalUnrelatedUserListParams,) => {
    return [`/internal/users/`, ...(params ? [params]: [])] as const;
    }

    
export const getInternalUnrelatedUserListQueryOptions = <TData = Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError = unknown>(params: InternalUnrelatedUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalUnrelatedUserListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalUnrelatedUserList>>> = ({ signal }) => internalUnrelatedUserList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalUnrelatedUserListQueryResult = NonNullable<Awaited<ReturnType<typeof internalUnrelatedUserList>>>
export type InternalUnrelatedUserListQueryError = unknown

export const useInternalUnrelatedUserList = <TData = Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError = unknown>(
 params: InternalUnrelatedUserListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalUnrelatedUserListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalUnrelatedUserListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError = unknown>(params: InternalUnrelatedUserListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalUnrelatedUserListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalUnrelatedUserList>>> = ({ signal }) => internalUnrelatedUserList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalUnrelatedUserListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalUnrelatedUserList>>>
export type InternalUnrelatedUserListSuspenseQueryError = unknown

export const useInternalUnrelatedUserListSuspense = <TData = Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError = unknown>(
 params: InternalUnrelatedUserListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalUnrelatedUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalUnrelatedUserListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalUnrelatedUserListLoader = (queryParamsOrFn: (InternalUnrelatedUserListParams | ((params: Params) => InternalUnrelatedUserListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getInternalUnrelatedUserListQueryKey(queryParams),
            queryFn: () => internalUnrelatedUserList(queryParams),
          }).then(() => null);
        });
      /**
 * Lists all users.
 */
export const internalAllUserList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UserReadDataList>(
      {url: `/internal/users/all`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalAllUserListQueryKey = () => {
    return [`/internal/users/all`] as const;
    }

    
export const getInternalAllUserListQueryOptions = <TData = Awaited<ReturnType<typeof internalAllUserList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalAllUserListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalAllUserList>>> = ({ signal }) => internalAllUserList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalAllUserListQueryResult = NonNullable<Awaited<ReturnType<typeof internalAllUserList>>>
export type InternalAllUserListQueryError = unknown

export const useInternalAllUserList = <TData = Awaited<ReturnType<typeof internalAllUserList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalAllUserListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalAllUserListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalAllUserList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalAllUserListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalAllUserList>>> = ({ signal }) => internalAllUserList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalAllUserListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalAllUserList>>>
export type InternalAllUserListSuspenseQueryError = unknown

export const useInternalAllUserListSuspense = <TData = Awaited<ReturnType<typeof internalAllUserList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalAllUserList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalAllUserListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalAllUserListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalAllUserListQueryKey(),
          queryFn: () => internalAllUserList(),
        }).then(() => null));
      /**
 * Gets table data for all users along with their roles
 */
export const usersInternalTableDataRetrieve = (
    params: UsersInternalTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/internal/users/table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getUsersInternalTableDataRetrieveQueryKey = (params: UsersInternalTableDataRetrieveParams,) => {
    return [`/internal/users/table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getUsersInternalTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError = unknown>(params: UsersInternalTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersInternalTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>> = ({ signal }) => usersInternalTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersInternalTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>>
export type UsersInternalTableDataRetrieveQueryError = unknown

export const useUsersInternalTableDataRetrieve = <TData = Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError = unknown>(
 params: UsersInternalTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersInternalTableDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUsersInternalTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError = unknown>(params: UsersInternalTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersInternalTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>> = ({ signal }) => usersInternalTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersInternalTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>>
export type UsersInternalTableDataRetrieveSuspenseQueryError = unknown

export const useUsersInternalTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError = unknown>(
 params: UsersInternalTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersInternalTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersInternalTableDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUsersInternalTableDataRetrieveLoader = (queryParamsOrFn: (UsersInternalTableDataRetrieveParams | ((params: Params) => UsersInternalTableDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getUsersInternalTableDataRetrieveQueryKey(queryParams),
            queryFn: () => usersInternalTableDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Updates table data for all user roles
 */
export const usersInternalTableDataUpdate = (
    userRoleUpdateAPIDataRequest: UserRoleUpdateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/internal/users/table-data/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userRoleUpdateAPIDataRequest
    },
      options);
    }
  


export const getUsersInternalTableDataUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersInternalTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof usersInternalTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersInternalTableDataUpdate>>, {data: UserRoleUpdateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersInternalTableDataUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersInternalTableDataUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersInternalTableDataUpdate>>>
    export type UsersInternalTableDataUpdateMutationBody = UserRoleUpdateAPIDataRequest
    export type UsersInternalTableDataUpdateMutationError = unknown

    export const useUsersInternalTableDataUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersInternalTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getUsersInternalTableDataUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    